class MediaMentionsSwiper extends HTMLElement {
    constructor() {
        super();
        this.mainSwiper = null;
        this.thumbSwiper = null;
        this.mainSwiperContainer = this.querySelector('.main-content-swiper .swiper');
        this.thumbSwiperContainer = this.querySelector('.thumb-image-swiper .swiper');
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.thumbSwiperContainer) {
            this.thumbSwiper = new Swiper(this.thumbSwiperContainer, {
                loop: true,
                autoplay: {
                    disableOnInteraction: false,
                },
                slidesPerView: 'auto',
                spaceBetween: 80,
                slideToClickedSlide: true,
                centeredSlides: true,
                on: {
                    transitionEnd: function () {
                        this.loopFix();
                    },
                },
            });
        }

        if (this.mainSwiperContainer && this.thumbSwiper) {
            this.mainSwiper = new Swiper(this.mainSwiperContainer, {
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                fadeEffect: {
                    crossFade: true,
                },
                // thumbs: {
                //     swiper: this.thumbSwiper,
                // }
            });

            this.thumbSwiper.on('slideChange', () => {
                const currentIndex = this.thumbSwiper.realIndex;
                this.mainSwiper.slideTo(currentIndex);
            });
        }
    }
}

customElements.define('media-mentions-swiper', MediaMentionsSwiper);
